module.exports = __webpack_public_path__ + "img/2.b0f5167a.png";